import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

import { SxProps } from "@mui/material";

import { useIsDesktop } from "@/hooks/layout";

import { InfoLink } from "../InfoStack/components";

interface ICreditTextProps {
  composer: string;
  songName: string;
  videoUrl: string;
  spotifyUrl: string;
  sx?: SxProps;
}

const CreditText: FC<ICreditTextProps> = ({ songName, composer, videoUrl, spotifyUrl, sx }) => {
  const { t } = useTranslation("downloadModal");

  const isDesktop = useIsDesktop();

  return (
    <Trans
      i18nKey="creditTextCopyright"
      t={t}
      components={[
        <InfoLink
          sx={{
            textDecoration: "none !important",
            fontSize: `${isDesktop ? "16px" : "12px"} !important`,
            ...sx,
          }}
        />,
      ]}
      values={{
        composer: composer || "[Paste Artist",
        songName: songName || "Track]",
        sign: composer && songName ? "-" : "&",
        videoUrl: videoUrl || "[Paste link to Audio Sanctum YT video]",
        spotifyUrl: spotifyUrl || "https://spotify.audiosanctum.com",
      }}
      tOptions={{
        interpolation: {
          escapeValue: false, // Prevent escaping of special characters
        },
      }}
    />
  );
};

export default CreditText;
